import React from "react";
import "./spinner.css";

const Spinner = ({ text, contained = false, opacity = "0.8" }) => (
    <div
        style={{
            opacity,
            zIndex: "2500",
            position: contained ? "absolute" : "fixed"
        }}
        className="modal-backdrop fade show"
    >
        <div className="spinner-container">
            <div className="spinner" />
            <div className="spinner-text font-weight-bold">
                {text || "Loading..."}
            </div>
        </div>
    </div>
);

export default Spinner;